// extracted by mini-css-extract-plugin
module.exports = {"statText":"session-statistics-71ab08da6b5117ccc4364f145a9eca57"};